module.exports = __webpack_public_path__ + "dfbcd738834db565cc8abceb5bb22dc2.pdf";